// @general/settings - frontend surface.

export const routes = [
  {
    path: '/settings',
    name: 'settings',
    component: () => import('./views/SettingsView.vue'),
    meta: { permission: 'settings:read', title: 'settings.title' },
  },
]

export const navigation = [
  { to: '/settings', labelKey: 'settings.title', permission: 'settings:read', icon: 'sliders', group: 'platform' },
]

export default { routes, navigation }
